import { Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";
import IDMELogo from "../../../images/icons/IDme.svg";
import { BtnGroupStyle, DRxCheckboxStyle } from "../../../Theme";
import { useEffect, useState } from "react";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import CheckboxActive from "../../../images/icons/checkboxactive.svg";
import { YSButton } from "../../../uikit/YSButton";
import { Checkbox } from "@mui/material";
import IdmeExternalWindowIcon from "../../../images/icons/IdmeExternalWindowIcon";
import IdmeInternalWindowIcon from "../../../images/icons/IdmeInternalWindowIcon";
import { useDispatch } from "react-redux";
import {
  setRoute,
  setRouteEnabled,
  setSteps,
} from "../../../Redux/Slice/IdmeSlice";

export default function SelectAuthentication({ URL, userUuidData }: any) {
  const dispatch = useDispatch();
  const [savePreference, setSavePreference] = useState<boolean>(false);
  const [authentication, setAuthentication] = useState<string | null>(null);

  useEffect(() => {
    const handleThings = (isInIframe: Boolean) => {
      if (userUuidData?.savedPreferenceForRoute === 0 && isInIframe === false) {
        setAuthentication("0");
        localStorage.setItem("savedPreferenceForRoute", "0");
      } else if (
        userUuidData?.savedPreferenceForRoute === 1 ||
        isInIframe === true
      ) {
        setAuthentication("1");
        dispatch(setRoute("1"));
      }
    };
    handleThings(window.self !== window.top);
  }, []);

  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital Rx" height={30} />
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Box className="iconCheckboxes">
            <Box
              style={{
                pointerEvents: window.self !== window.top ? "none" : "auto",
                opacity: window.self !== window.top ? 0.5 : 1,
              }}
              className={
                authentication === "0" ? "iconCheckbox active" : "iconCheckbox"
              }
              onClick={() => {
                setAuthentication("0");
                dispatch(setRoute("0"));
              }}
            >
              <img src={CheckboxActive} alt="" className="checkmark" />
              <IdmeExternalWindowIcon />
              <Typography
                component={"div"}
                margin={0}
                padding={0}
                variant={"subtitle1"}
                fontWeight={600}
              >
                Redirect to ID.ME
              </Typography>
              <Typography
                component={"div"}
                margin={0}
                padding={0}
                variant={"body2"}
              >
                Redirects to ID.ME to complete 2FA and redirect back to H2H
                DigitalRx -{" "}
                {window.self !== window.top && (
                  <Typography
                    margin={0}
                    padding={0}
                    display="inline"
                    variant={"body2"}
                    color="error"
                  >
                    You can't use this feature inside an iframe.
                  </Typography>
                )}
              </Typography>
            </Box>
            <Box
              className={
                authentication === "1" ? "iconCheckbox active" : "iconCheckbox"
              }
              onClick={() => {
                setAuthentication("1");
                dispatch(setRoute("1"));
              }}
            >
              <img src={CheckboxActive} alt="" className="checkmark" />{" "}
              <IdmeInternalWindowIcon />
              <Typography
                component={"div"}
                margin={0}
                padding={0}
                variant={"subtitle1"}
                fontWeight={600}
              >
                Complete 2FA within H2H Digital Rx
              </Typography>
              <Typography
                component={"div"}
                margin={0}
                padding={0}
                variant={"body2"}
              >
                Continue 2FA process within H2H Digital Rx
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6} textAlign="left">
          <DRxCheckboxStyle
            style={{ marginTop: 20, display: "flex", alignItems: "center" }}
          >
            <Checkbox
              id="savePreference"
              inputProps={{ "aria-label": "controlled" }}
              checked={savePreference}
              disabled={authentication ? false : true}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSavePreference(e.target.checked);
                dispatch(setRouteEnabled(e.target.checked));
              }}
            />
            <Typography
              htmlFor="savePreference"
              className="usefreetext"
              variant="body2"
              component={"label"}
            >
              Save this as a preference
            </Typography>
          </DRxCheckboxStyle>
        </Grid>
        <Grid item xs={6} textAlign="right">
          <BtnGroupStyle className="right">
            <YSButton
              children="Continue"
              variant="contained"
              type="button"
              disabled={authentication ? false : true}
              onClick={() => {
                if (authentication === "0") {
                  if (
                    userUuidData?.savedPreferenceForRoute !== 0 &&
                    savePreference === true
                  ) {
                    localStorage.setItem("savedPreferenceForRoute", "0");
                  }
                  localStorage.removeItem("userIdmeUuid");
                  window.open(`${URL}`, "_self");
                } else if (authentication === "1") {
                  dispatch(setSteps("two"));
                } else {
                  dispatch(setSteps("one"));
                }
              }}
              size="large"
              className=""
            />
          </BtnGroupStyle>
        </Grid>
      </Grid>
    </>
  );
}
